var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13193",
    "data-name": "Group 13193",
    transform: "translate(-992 -413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_619",
    "data-name": "Ellipse 619",
    transform: "translate(992 413)",
    fill: "#fff",
    stroke: "rgba(17,17,17,0.3)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12644",
    "data-name": "Group 12644",
    transform: "translate(1002.313 423.322)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M1646.945,5402.9c.236-.265.431-.534.673-.763a3.694,3.694,0,0,1,2.656-1.048,6.172,6.172,0,0,1,1.67.2,3.266,3.266,0,0,1,2.318,2.438,10.213,10.213,0,0,1,.308,2.792c0,1.985-.006,3.971,0,5.955,0,.186-.051.234-.234.232q-1.534-.01-3.068,0c-.18,0-.218-.056-.218-.225q.009-2.834,0-5.667a5.072,5.072,0,0,0-.165-1.406,1.583,1.583,0,0,0-1.739-1.234,1.9,1.9,0,0,0-2,1.9,7,7,0,0,0-.055.886c0,1.836,0,3.673,0,5.51,0,.184-.045.238-.232.237q-1.545-.013-3.09,0c-.166,0-.214-.044-.213-.21q.006-5.457,0-10.91c0-.181.059-.222.229-.222q1.467.013,2.935,0c.18,0,.226.057.223.229C1646.938,5402.027,1646.945,5402.463,1646.945,5402.9Z",
    transform: "translate(-1637.541 -5395.725)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M1640.115,5407.115c0,1.8,0,3.6,0,5.4,0,.2-.049.26-.256.259-1.022-.013-2.044-.009-3.067,0-.164,0-.214-.04-.213-.208q.007-5.465,0-10.93c0-.149.036-.205.2-.205,1.036.009,2.074.011,3.111,0,.2,0,.227.076.226.247Q1640.111,5404.393,1640.115,5407.115Z",
    transform: "translate(-1636.314 -5395.784)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M1640.339,5396.612a2.042,2.042,0,1,1-2.038-2.03A2.05,2.05,0,0,1,1640.339,5396.612Z",
    transform: "translate(-1636.256 -5394.582)",
    fill: "#ef7b13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedIn_icon.0fd5c149ea910eecf9f1b71da54fd778.svg";
export { ForwardRef as ReactComponent };